import React, { Component } from 'react';
import Multiselect from 'react-widgets/lib/Multiselect';
import styled from 'styled-components';

import 'react-widgets/dist/css/react-widgets.css';

import CountiesBg from '../../../images/countries.png';

export const ModalInputBox = styled.div`
  position: relative;
  width: 100%;
  min-height: 80px;

  .labelSpan {
    display: block;
    margin-bottom: 5px;
    font-size: 14px;
  }

  .rw-select {
    display: none !important;
  }

  .rw-state-disabled .rw-widget-container input {
    cursor: not-allowed;
  }

  .rw-widget-container {
    input {
      margin-top: 4px;
      padding: 0 4px;
    }
  }

  .rw-multiselect-taglist {
    li {
      display: flex;
      display: -ms-flexbox;
      align-items: center;
      font-size: 12px;
    }
  }

  .rw-widget-input.rw-widget-picker.rw-widget-container {
    min-height: 40px;
    padding: 5px;
    border-radius: 0;
    border-color: #ccc !important;
    display: block;

    & > div {
      display: flex;
      flex-wrap: wrap;
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      max-width: 100%;

      li {
        min-width: 25px;
        margin: 3px;
        span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: auto;
        }

        > * {
          display: inline-block;
          height: auto;
        }
      }
    }
  }

  .rw-multiselect .rw-input-reset {
    height: auto !important;
    font-size: 14px;
    color: gray;
  }

  .rw-btn.rw-btn-select {
    opacity: 1 !important;
  }

  .rw-list-empty {
    padding: 5px;
    font-size: 12px;
  }

  .listOption {
    display: flex;
    align-items: center;
  }

  .flagBox {
    width: 15px;
    min-width: 15px;
    height: 15px;
    margin-right: 5px;
    background-image: url(${CountiesBg});
  }
`;

const ErrorMessage = styled.div`
  padding: 3px 0 0;
  font-size: 12px;
  color: #ff3b30;
`;

class MultiSelect extends Component {
  checkArrayType = (type, item) => {
    switch (type) {
      case 'countriesMulti':
        return this.listItem(item);
      case 'competitions':
      case 'categoryList':
        return this.categoryItem(item);
      case 'typeForms':
        return this.typeFormsItem(item);
      case 'typeFormsMulti':
        return this.typeFormsMultiSelect(item);
      case 'roleList':
        return this.roleList(item);
      default:
        return this.commonList(item);
    }
  };

  listItem = ({ item }) => (
    <div className="listOption">
      {item.flag ? (
        <span
          className="flagBox"
          style={{ backgroundPosition: `${this.setFlagPosition(item.flag)}` }}
        />
      ) : (
        <span className="flagBox" />
      )}
      <span>{item.name}</span>
    </div>
  );

  setFlagPosition = (flagPosition) => {
    return `-1px -${flagPosition * 16}px`;
  };

  categoryItem = ({ item }) => (
    <div className="listOption">
      <span>{item.name}</span>
    </div>
  );

  typeFormsItem = ({ item }) => (
    <div className="listOption">
      <span>{item.title}</span>
    </div>
  );

  typeFormsMultiSelect = ({ item }) => (
    <div className="listOption">
      <span>{item.label}</span>
    </div>
  );

  commonList = ({ item }) => (
    <div className="listOption">
      <span>{item}</span>
    </div>
  );

  roleList = ({ item }) => (
    <div className="listOption">
      <span>{item.label}</span>
    </div>
  );

  render() {
    const { data, textField, meta, input, label, type, dataKey } = this.props;

    return (
      <ModalInputBox>
        <span className="labelSpan">{label}</span>
        <Multiselect
          onChange={input.onChange}
          value={input.value || []}
          dataKey={dataKey}
          data={data}
          textField={textField}
          itemComponent={(item) => this.checkArrayType(type, item)}
        />

        {meta.touched && meta.error && (
          <ErrorMessage show={meta.touched && meta.error}>{meta.error}</ErrorMessage>
        )}
      </ModalInputBox>
    );
  }
}

export default MultiSelect;
